// extracted by mini-css-extract-plugin
export default {"secondary-icon":"OjUDGhBqPUB-QzmwX5bZO8m2PBTdGxqE4VYqBU6JadQ=","icon":"ACUTVX779PRKDz6tynRRkLkbMAxMG+S8nI8mnTx-cdE="};